<template>
    <div :class="getDropdownClasses()">
        <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Bulk Action <span class="caret" />
        </button>
        <ul class="dropdown-menu">
            <li v-for="(action, name, index) in bulkActionOptions" :key="index">
                <button class="btn btn-default btn-block" type="submit" name="bulkaction" :value="name">
                    <div class="text-left">
                         <i :class="getIconClasses(action.classes)" /> {{ action.text }}
                    </div>
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "BulkAction",
    props: {
        bulkActionOptions: {
            type: Object,
            default: () => ({})
        },

        reversed: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        getIconClasses: function (icon) {
            return "fa fa-fw " + icon
        },

        getDropdownClasses: function () {
            return this.reversed ? "btn-group dropup" : "btn-group"
        },
    }
}
</script>
